export default __webpack_public_path__ + "static/media/001.d6961860.jpg";